"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewUsers = void 0;
const React = __importStar(require("react"));
const PageContent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/content/PageContent"));
const antd_1 = require("antd");
const ProjectDashboardDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/dashboard/ProjectDashboardDataProvider");
const ProjectDashboardHighchartsOptionsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/highcharts/ProjectDashboardHighchartsOptionsProvider");
const react_router_dom_1 = require("react-router-dom");
const AppRouting_1 = require("src/hello_assets/src/components/system/AppRouting");
const CurrentProjectProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/CurrentProjectProvider");
const NewUsersPopover_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/common/help/NewUsersPopover");
const HighchartsComponentWrapper_1 = require("src/hello_assets/src/components/ui/common/content/highcharts/HighchartsComponentWrapper");
const HighchartsOptionsProvider_1 = require("src/hello_assets/src/components/ui/common/content/highcharts/HighchartsOptionsProvider");
const title = "New Users";
const NewUsers = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const { projectApiKey } = (0, CurrentProjectProvider_1.useCurrentProjectContext)();
    const currentProjectDataContext = (0, ProjectDashboardDataProvider_1.useProjectDashboardDataContext)();
    const state = currentProjectDataContext.stateQueryCalls;
    if ((_b = (_a = state.data) === null || _a === void 0 ? void 0 : _a.newUsers) === null || _b === void 0 ? void 0 : _b.isError) {
        return React.createElement(React.Fragment, null,
            React.createElement(PageContent_1.default.CardSection, null, title),
            React.createElement(antd_1.Result, { className: "ug-result-noIcon", status: "error", icon: React.createElement(React.Fragment, null), subTitle: React.createElement(React.Fragment, null,
                    "Oops, something went wrong.",
                    React.createElement("br", null),
                    title,
                    " cannot be loaded. Please try again.") }));
    }
    const inProgress = state.inProgress;
    const stateError = {
        isError: ((_d = (_c = state.data) === null || _c === void 0 ? void 0 : _c.newUsers) === null || _d === void 0 ? void 0 : _d.isError) === true,
        error: (_f = (_e = state.data) === null || _e === void 0 ? void 0 : _e.newUsers) === null || _f === void 0 ? void 0 : _f.error
    };
    return React.createElement(React.Fragment, null,
        React.createElement(PageContent_1.default.CardSection, null,
            React.createElement(antd_1.Space, null,
                React.createElement(react_router_dom_1.Link, { to: AppRouting_1.AppPathGenerator.Project.newUsers(projectApiKey) }, title),
                React.createElement(NewUsersPopover_1.NewUsersPopover, null))),
        React.createElement(antd_1.Row, { gutter: [32, 16] },
            React.createElement(antd_1.Col, { span: 24, lg: 12 },
                React.createElement(HighchartsOptionsProvider_1.HighchartsOptionsProvider, { error: stateError, data: (_j = (_h = (_g = state.data) === null || _g === void 0 ? void 0 : _g.newUsers) === null || _h === void 0 ? void 0 : _h.state) === null || _j === void 0 ? void 0 : _j.newUsers, parameters: { chartTitle: "New Users" }, highchartsOptionsProviderFn: ProjectDashboardHighchartsOptionsProvider_1.ProjectDashboardHighchartsOptionsProvider.optionsForChartLastNIntervalData },
                    React.createElement(HighchartsOptionsProvider_1.HighchartsOptionsContext.Consumer, null, context => {
                        return React.createElement(HighchartsComponentWrapper_1.HighchartsComponentWrapper, { highchartsOptionsState: context.state, inProgress: inProgress });
                    }))),
            React.createElement(antd_1.Col, { span: 24, lg: 12 },
                React.createElement(HighchartsOptionsProvider_1.HighchartsOptionsProvider, { error: stateError, data: (_m = (_l = (_k = state.data) === null || _k === void 0 ? void 0 : _k.newUsers) === null || _l === void 0 ? void 0 : _l.state) === null || _m === void 0 ? void 0 : _m.newUsersCumulative, parameters: { chartTitle: "New Users Cumulative" }, highchartsOptionsProviderFn: ProjectDashboardHighchartsOptionsProvider_1.ProjectDashboardHighchartsOptionsProvider.optionsForChartLastNIntervalData },
                    React.createElement(HighchartsOptionsProvider_1.HighchartsOptionsContext.Consumer, null, context => {
                        return React.createElement(HighchartsComponentWrapper_1.HighchartsComponentWrapper, { highchartsOptionsState: context.state, inProgress: inProgress });
                    })))));
};
exports.NewUsers = NewUsers;
